
export class CalculatorContainer {
  private container: HTMLElement;
  
  constructor() {
    this.container = document.createElement('div');
    this.container.className = 'onexip-calculator-container';
  }
  
  getElement(): HTMLElement {
    return this.container;
  }
  
  reset(): void {
    while (this.container.firstChild) {
      this.container.removeChild(this.container.firstChild);
    }
  }
}
